// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"6b8ffad1","124":"3ea0f1de","129":"fa929acb"}[chunkId] + ".chunk.js";
};